import { PartialType, PickType } from '@nestjs/swagger';
import { JobPhaseDto } from './job-phase.dto';
import { JobPhaseLogBumpInterface } from '../interfaces/job-phase-log-bump.interface';

export class JobPhaseLogBumpDto
  extends PartialType(
    PickType(JobPhaseDto, ['id', 'contractorId', 'dateStart']),
  )
  implements JobPhaseLogBumpInterface {}
